import React, { FC } from 'react';

import {
  TelegramModal,
  CashBoxModal,
  CloudPaymentsModal,
  KaspiOnlineModal,
  TinkoffModal,
  StripeModal,
  BePaidModal,
} from './components';
import { IModals } from './interfaces';

export const Modals: FC<IModals> = ({ type, close }) => {
  switch (type) {
    case 'TELEGRAM':
      return <TelegramModal onClose={close} />;
    case 'CASH_BOX':
      return <CashBoxModal onClose={close} />;
    case 'CLOUDPAYMENTS':
      return <CloudPaymentsModal onClose={close} />;
    case 'KASPI_ONLINE':
      return <KaspiOnlineModal onClose={close} />;
    case 'TINKOFF':
      return <TinkoffModal onClose={close} />;
    case 'STRIPE':
      return <StripeModal onClose={close} />;
    case 'BE_PAID':
      return <BePaidModal onClose={close} />;
    default:
      return null;
  }
};
